// LabelBasicTable.tsx
import React from 'react';
import { useProjectDetailsContext } from '../contexts/ProjectDetailsContext';
import { useNavigateWithinProject } from '../utils/navigation';
import { formatDate } from '../utils/timeUtils';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Avatar from './Avatar';
import StatusIndicator from './StatusIndicator';
import EllipsisOptions from './EllipsisOptions';
import '../styles/components/LabelBasicTable.scss';

const LabelBasicTable: React.FC = () => {
    const {
        state: { labels, userDetailsMapping, labelThumbnailUrls },
        handlers: { handleLabelDelete },
    } = useProjectDetailsContext();

    const navigate = useNavigateWithinProject();

    const handleSelect = (labelId: string) => {
        navigate(`/labels/${labelId}`);
    };

    // const getStatusText = (status: ApprovalStatus) => {
    //     switch (status) {
    //         case ApprovalStatus.APPROVED:
    //             return 'Approved';
    //         case ApprovalStatus.REJECTED:
    //             return 'Rejected';
    //         case ApprovalStatus.REFERRED:
    //             return 'Referred';
    //         case ApprovalStatus.PENDING:
    //             return 'Pending';
    //         default:
    //             return 'Unknown';
    //     }
    // };

    return (
        <div className="table-container margin-top-16">
            {labels.length > 0 ? (
                <table className="base-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Version</th>
                            <th>Uploaded By</th>
                            <th>Date</th>
                            <th>Approval Status</th>
                            <th></th> {/* Empty header for action button */}
                        </tr>
                    </thead>
                    <tbody>
                        {labels.map((label) => {
                            const userDetails =
                                userDetailsMapping[label.creation.user_id];
                            const userName = userDetails
                                ? `${userDetails.first_name} ${userDetails.last_name}`
                                : 'Unknown User';
                            const userEmail = userDetails
                                ? userDetails.email_address
                                : 'Unknown Email';
                            return (
                                <tr
                                    key={label.id}
                                    onClick={() => handleSelect(label.id)}
                                    className="label-row"
                                >
                                    <td className="label-thumbnail-cell">
                                        {labelThumbnailUrls[label.id] && (
                                            <img
                                                src={
                                                    labelThumbnailUrls[label.id]
                                                }
                                                alt={label.name}
                                            />
                                        )}
                                    </td>
                                    <td className="version-cell">
                                        <div className="version-name">
                                            {label.name}
                                        </div>
                                        {label.notes && (
                                            <div className="label-notes">
                                                {label.notes}
                                            </div>
                                        )}
                                    </td>
                                    <td>
                                        <div className="user-details-container">
                                            <Avatar
                                                userDetails={
                                                    userDetailsMapping[
                                                        label.creation.user_id
                                                    ]
                                                }
                                                showTooltip={false}
                                                height={32}
                                            />
                                            <div className="text">
                                                <p className="user-name">
                                                    {userName}
                                                </p>
                                                <p className="user-email">
                                                    {userEmail}
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {formatDate(label.creation.timestamp)}
                                    </td>
                                    <td>
                                        <div className="status-container">
                                            <StatusIndicator
                                                decision={label.approval_status}
                                                isBig={true}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <EllipsisOptions
                                            options={[
                                                {
                                                    icon: faTrash,
                                                    label: 'Delete',
                                                    onClick: () =>
                                                        handleLabelDelete(
                                                            label.id,
                                                        ),
                                                    variant: 'danger',
                                                },
                                            ]}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            ) : (
                <p className="no-results-message">No labels uploaded yet.</p>
            )}
        </div>
    );
};

export default LabelBasicTable;
